// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__16-Er","empty":"ModalGraph_empty__1CXUk"};